import React from 'react'
import {withRouter} from 'react-router-dom'
import {Col, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap'
import Loader from 'react-loader-spinner'
import classnames from 'classnames'
import {AppError, User} from '../../../models'
import {getTeam, getUser, updateUser, getIntegrationForTeam, WS_URL} from "../../../api"
import Websocket from "react-websocket"
import {pageHelpers} from '../'
import {AccountSettingsForm, NotificationPreferencesForm, AdminLinkBubble} from '../../ui'
import AccountIcon from 'react-icons/lib/fa/user'
import NotificationIcon from 'react-icons/lib/fa/bullhorn'

class ViewPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        pageHelpers.setupSingleRunAnimationEvents()
        const {token} = props

        let userID
        let user
        if (this.urlParams.user_id) {
            userID = this.urlParams.user_id
            user = null
        } else if (this.user && this.user.id) {
            userID = this.user.id
            user = this.user
        }

        this.state = {
            userID,
            user,
            token,
            teams: [],
            activeTeam: null,
            loading: false,
            savingAccountSettings: false,
            savingNotificationPreferences: false,
            activeTab: this.queryParams.tab || "1",
            errors: [],
            integration: null,
        }

        this.switchTab = this.switchTab.bind(this)
        this.fetchUser = this.fetchUser.bind(this)
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)

        let userID
        let user
        if (this.urlParams.user_id) {
            userID = this.urlParams.user_id
            user = null
        } else if (this.user && this.user.id) {
            userID = this.user.id
            user = this.user
        }

        const {token} = nextProps
        let activeTab = this.queryParams.tab || "1"
        this.setState({activeTab, token})

        if (user && user.activeTeam && this.state.user && this.state.user.activeTeam && user.activeTeam !== this.state.user.activeTeam) {
            this.history.push(`${this.history.location.pathname}?tab=${activeTab}&team=${user.activeTeam}`)
            await this.setState({activeTeam:user.activeTeam, user, userID})
            this.setState({loadingNotificationPreferences: true})
            await this.fetchUser()
            this.setState({loadingNotificationPreferences: false})
        } else if (user && user.activeTeam || this.urlParams.user_id) {
            await this.setState({user, userID})
            this.setState({loadingNotificationPreferences: true})
            await this.fetchUser()
            this.setState({loadingNotificationPreferences: false})
        }
    }

    async componentDidMount() {
        if (this.state.token) {
            this.setState({loading: true})
            await this.fetchUser()
            this.setState({loading: false})
        }
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    async switchTab(tab) {
        let {activeTab } = this.state
        if (activeTab !== tab) {
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?tab=${tab}`
            })
        }
    }

    async fetchUser() {
        let {userID, user, token} = this.state
        try {

            let teamID = this.queryParams.team
            if (!teamID && user) {
                teamID = user.activeTeam
            }

            if (teamID) {
                user = await getUser(token, userID, teamID)
            } else {
                user = await getUser(token, userID)
                teamID = user.activeTeam
            }

            let activeTeam = null
            if (user && user.teams && user.teams.length > 0) {
                activeTeam = parseInt(teamID)
            }

            let teams = []
            for (let i = 0; i < user.teams.length; i++) {
                let team = await getTeam(token, user.teams[i], 'pico')
                teams.push(team)
            }
            let integration = await getIntegrationForTeam(user.activeTeam, this.token)
            
            this.setState({user, activeTeam, teams, integration})
        } catch (error) {
            console.log(error)
        }
        this.setState({loading: false})
    }

    async handleValidSubmit(event, values) {
        event.preventDefault()

        let userFormValues = values
        let userFormKeys = Object.keys(userFormValues)
        let {user, token} = this.state

        userFormKeys.map(key => {
            let value = userFormValues[key]
            if (String(typeof value).toLowerCase() === "string" && value.length < 1 && key !== "phone") {
                value = user[key]
            }

            if (key !== "confirmPassword") {
                user[key] = value
            }
        })

        if (userFormKeys.includes('firstName')) {
            this.setState({loadingAccountSettings: true})
        } else if (userFormKeys.includes('phone')) {
            this.setState({loadingNotificationPreferences: true})
        }

        try {
            let newUser = await updateUser(token, user, values.password)
            this.setState({user: newUser})
        } catch (error) {
            let appError = new AppError('Failed to update account info', error.message)
            this.setState({errors: [appError]})
        } finally {
            if (userFormKeys.includes('firstName')) {
                this.setState({loadingAccountSettings: false})
            } else if (userFormKeys.includes('phone')) {
                this.setState({loadingNotificationPreferences: false})
            }
        }
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let oldUser = this.state.user
        let user = User.fromAPIObject(result, oldUser.activeTeam)
        if (user.id === oldUser.id) {
            this.setState({user})
        }
    }

    render() {
        let {errors, user, loading, loadingAccountSettings, loadingNotificationPreferences, activeTeam, teams, activeTab, integration, token} = this.state

        return (loading || !user ?
                <Loader type="TailSpin" color="orange" width={60} height={60}/> :
                    <div className="m-0 p-0">
                        <Col xs={12} className="p-0">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: activeTab === '1'})}
                                        onClick={() => {
                                            this.switchTab('1')
                                        }}
                                    >
                                        <AccountIcon className="mr-2"/>
                                        Account
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: activeTab === '2'})}
                                        onClick={() => {
                                            this.switchTab('2')
                                        }}
                                    >
                                        <NotificationIcon className="mr-2"/>
                                        Notifications
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col xs={12} className="bg-light p-0 pb-4 rounded border-light-sf-orange justify-content-center text-left">
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <AccountSettingsForm onValidSubmit={this.handleValidSubmit}
                                                           onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}
                                                           user={user}
                                                           loading={loadingAccountSettings}
                                                           managingOtherUser={this.user.isSupport && user.id !== this.user.id}/>
                                </TabPane>
                                <TabPane tabId="2">
                                    <NotificationPreferencesForm loading={loadingNotificationPreferences}
                                                                     onValidSubmit={this.handleValidSubmit}
                                                                     onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}
                                                                     activeTeam={activeTeam} user={user} teams={teams}
                                                                     history={this.history}
                                                                     integration={integration}/>
                                </TabPane>
                            </TabContent>

                            {pageHelpers.renderErrorModalsForPage(errors, this)}
                            {(user && token ?
                                <Websocket url={`${WS_URL}/users/${user.id}/?access_token=${token.accessToken}`}
                                           onMessage={this.handleWebSocketResponse}/> : null)}
                        </Col>

                        {user && user.id && this.user && this.user.isSupport ?
                            <AdminLinkBubble url={`auth/user/${user.id}`}
                                                modelName="User"
                                                className="mt-2"/> :
                            null}
                    </div>)
    }
}

export default withRouter(ViewPage)



// WEBPACK FOOTER //
// ./src/components/pages/users/ViewPage.js